import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconRemoveComponent } from "./med-icon-remove.component";

@NgModule({
  declarations: [
    MedIconRemoveComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconRemoveComponent,
  ],
})
export class MedIconRemoveModule { }
